angular.module('app.reportesService', [

])

.factory('reportesService', ['$http', '$q', 'appSettings', function ( $http, $q, appSettings ) {
return {

    // getListadoReportes: function() {
    //     var deferred = $q.defer();
    //     $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/getListadoReportes')
    //     .then(successCallback, errorCallback);
    //         function successCallback(data){
    //             //success code
    //             deferred.resolve( data );
    //             //toastr.success("Consumi Servicio")
    //         }
    //         function errorCallback(error){
    //             //error code
    //             deferred.reject( error );
    //             //toastr.error("Fallo Consumir Servicio" + error)
    //         }

    //     return deferred.promise;

    // },

    getParametrosReporte: function(p_id_reporte) {

        var deferred = $q.defer();
        $http.get(appSettings.restOAUTH + 'Reportes/Reporte/'+p_id_reporte+'/getParametrosReporte')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }

        return deferred.promise;

    },

    getCatalogoReporte: function(p_id_reporte_parametro) {

        var deferred = $q.defer();
        $http.get(appSettings.restOAUTH + 'Reportes/Reporte/'+p_id_reporte_parametro+'/getCatalogoReporte')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }

        return deferred.promise;

    },

    getCatalogoReporteDinamico: function(data) {
            var deferred = $q.defer();
            $http.post(appSettings.restOAUTH + 'Reportes/Reporte/getCatalogoReporteDinamico',data)
            .then(successCallback, errorCallback);
            function successCallback(data){
                deferred.resolve( data );
              }
              function errorCallback(error){
                        //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
              }
            return deferred.promise;
          }, 

    insReporteSolicitud: function(data) {
        var deferred = $q.defer();
        $http.post(appSettings.restOAUTH + 'Reportes/insReporteSolicitud',data)
        .then(successCallback, errorCallback);
        function successCallback(data){
            deferred.resolve( data );
          }
          function errorCallback(error){
                    //error code
            deferred.reject( error );
            //toastr.error("Fallo Consumir Servicio" + error)
          }
        return deferred.promise;
      },

      generarReportePDF: function (id){
        window.open(appSettings.restOAUTH + 'Reportes/solicitudReporte/' + id + '/generarReportePDF', '_blank');
    },
    generarReporteExcel: function (id){
        window.open(appSettings.restOAUTH + 'Reportes/solicitudReporte/' + id + '/generarReporteExcel', '_blank');
    },
    generarReporteWord: function (id){
        window.open(appSettings.restOAUTH + 'Reportes/solicitudReporte/' + id + '/generarReporteWord', '_blank');
    },
    generarReporteDirecto: function (url){
        window.open(appSettings.restOAUTH + 'Reportes/generarReporteDirecto'+url, '_blank');
    }
}

}]);
